/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonComponent } from "../../button/button.component";

@Component({
	selector: "globalictcc-pagination",
	standalone: true,
	imports: [ButtonComponent],
	templateUrl: "./pagination.component.html",
	styleUrl: "./pagination.component.scss"
})
export class PaginationComponent {
	@Input() public totalItems: number;
	@Input() public pageSize: number;
	@Input() public currentPage: number;
	@Input() public totalPages: number;
	@Input() public pageItems: number;

	@Output() public handlePreviousPage = new EventEmitter<void>();
	@Output() public handleNextPage = new EventEmitter<void>();
}
